import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { withTranslation } from '../../src/i18n';

import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  cardBox: {
    height: 'auto',
    borderRadius: 4,
    boxShadow: '0 2px 10px 0 #eaeaea, inset 0 -1px 0 0 #eaeaea',
    backgroundColor: colors.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

const CardBox = ({ children, className }) => {
  const classes = useStyles();
  return <div className={classnames(classes.cardBox, className)}>{children}</div>;
};

CardBox.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default withTranslation('translation')(CardBox);
